;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React, { useRef } from "react"

import styles from "./styles.module.scss"
import styleGrayscaleHover from "../../styles.module.scss"
import Image from "next/image"
import map from "lodash/map"
import Slide from "@mui/material/Slide"

import {
  PICTURES_PAGE_0,
  PICTURES_PAGE_1,
  PICTURES_PAGE_2,
  PICTURES_PAGE_3,
} from "../constants"
const PICTUER_CONTAINER_UI = "absolute"
const PICTUER_CONTAINER_BORDER_UI = "absolute flex overflow-hidden"
function PictureSnowman({ page, previousPage, inactiveGrayScale }) {
  const containerRefPhoto0 = useRef(null)
  const containerRefPhoto1 = useRef(null)
  const containerRefPhoto2 = useRef(null)
  const containerRefPhoto3 = useRef(null)

  const getPictureSize = (index) => {
    if (index == 0) {
      return 142
    } else if (index == 1) {
      return 92
    } else if (index == 2) {
      return 54
    } else {
      return 38
    }
  }

  const directionToSlide = ({ index }) => {
    // new slide page
    if (index == page) {
      // going backwards
      if (
        (page == 0 && previousPage == 1) ||
        (page == 1 && previousPage == 2) ||
        (page == 2 && previousPage == 3) ||
        (page == 3 && previousPage == 0)
      ) {
        return "up"
      }
      return "down"
    } else {
      // else above mean this is the picture that is coming off the screen
      // if below means going backwards
      if (
        (page == 0 && previousPage == 1) ||
        (page == 1 && previousPage == 2) ||
        (page == 2 && previousPage == 3) ||
        (page == 3 && previousPage == 0)
      ) {
        return "down"
      }
      return "up"
    }
  }

  const renderPicture1 = () => {
    return (
      <div
        className={`${PICTUER_CONTAINER_BORDER_UI} ${
          styles[`picture-container-border-${1}`]
        }`}
        ref={containerRefPhoto0}
      >
        {map(PICTURES_PAGE_0, (picture, index) => {
          return (
            <Slide
              direction={directionToSlide({ index })}
              in={page == index}
              timeout={{ enter: 1000, exit: 1000 }}
              // unmountOnExit
              // mountOnEnter
              container={() => containerRefPhoto0.current}
              key={`1-slide-pic-snowman-${index}`}
            >
              <div
                className={`${PICTUER_CONTAINER_UI} ${
                  styles[`picture-container-${1}`]
                }`}
                key={`1-slide-pic-snowman-${index}-container`}
              >
                <Image
                  src={picture}
                  alt={`group leaders profile photo 1`}
                  // h-[90px] w-[90px] min-[600px]:h-[142px] min-[600px]:w-[142px]
                  className={`bg-black ${styles["grayscale"]} ${
                    inactiveGrayScale ? styles["inactive-grayscale"] : ""
                  }`}
                  fill={true}
                />
              </div>
            </Slide>
          )
        })}
      </div>
    )
  }

  const renderPicture2 = () => {
    return (
      <div
        className={`${PICTUER_CONTAINER_BORDER_UI} ${
          styles[`picture-container-border-${2}`]
        }`}
        ref={containerRefPhoto1}
      >
        {map(PICTURES_PAGE_1, (picture, index) => {
          return (
            <Slide
              direction={directionToSlide({ index })}
              in={page == index}
              timeout={{ enter: 1000, exit: 1000 }}
              // unmountOnExit
              // mountOnEnter
              container={() => containerRefPhoto1.current}
              key={`2-slide-pic-snowman-${index}`}
            >
              <div
                className={`${PICTUER_CONTAINER_UI} ${
                  styles[`picture-container-${2}`]
                }`}
                key={`2-slide-pic-snowman-${index}-container`}
              >
                <Image
                  src={picture}
                  alt={`group leaders profile photo 2`}
                  className={`bg-black ${styles["grayscale"]}`}
                  fill={true}
                />
              </div>
            </Slide>
          )
        })}
      </div>
    )
  }

  const renderPicture3 = () => {
    return (
      <div
        className={`${PICTUER_CONTAINER_BORDER_UI} ${
          styles[`picture-container-border-${3}`]
        }`}
        ref={containerRefPhoto2}
      >
        {map(PICTURES_PAGE_2, (picture, index) => {
          return (
            <Slide
              direction={directionToSlide({ index })}
              in={page == index}
              timeout={{ enter: 1000, exit: 1000 }}
              // unmountOnExit
              // mountOnEnter
              container={() => containerRefPhoto2.current}
              key={`3-slide-pic-snowman-${index}`}
            >
              <div
                className={`${PICTUER_CONTAINER_UI} ${
                  styles[`picture-container-${3}`]
                }`}
                key={`3-slide-pic-snowman-${index}-container`}
              >
                <Image
                  src={picture}
                  alt={`group leaders profile photo 3`}
                  className={`bg-black  ${styles["grayscale"]}`}
                  fill={true}
                />
              </div>
            </Slide>
          )
        })}
      </div>
    )
  }

  const renderPicture4 = () => {
    return (
      <div
        className={`${PICTUER_CONTAINER_BORDER_UI} ${
          styles[`picture-container-border-${4}`]
        }`}
        ref={containerRefPhoto3}
      >
        {map(PICTURES_PAGE_3, (picture, index) => {
          return (
            <Slide
              direction={directionToSlide({ index })}
              in={page == index}
              timeout={{ enter: 1000, exit: 1000 }}
              // unmountOnExit
              // mountOnEnter
              container={() => containerRefPhoto3.current}
              key={`slide-pic-snowman-${index}`}
            >
              <div
                className={`${PICTUER_CONTAINER_UI} ${
                  styles[`picture-container-${4}`]
                }`}
                key={`slide-pic-snowman-${index}-container`}
              >
                <Image
                  src={picture}
                  alt={`group leaders profile photo 4`}
                  className={`bg-black  ${styles["grayscale"]}`}
                  fill={true}
                />
              </div>
            </Slide>
          )
        })}
      </div>
    )
  }
  return (
    <div
      className={
        "relative w-[98px] h-[180px] min-[600px]:w-[150px] min-[600px]:h-[256px]"
      }
    >
      {renderPicture1()}
      {renderPicture2()}
      {renderPicture3()}
      {renderPicture4()}
    </div>
  )
}
export default PictureSnowman
